export class ClientError extends Error {
  constructor(data, httpStatus) {
    if (typeof data === 'string') {
      super(data);
      this.httpStatus = httpStatus ? httpStatus : 0;
    } else {
      super(data.message);
      this.errorCode = data.error;
      this.details = data;
      this.httpStatus = httpStatus ? httpStatus : data.statusCode;
    }
  }
}